import searchPopdown from '../features/header-search-popdown';
import { register } from './../exports/theme-sections';
import ticker from './../features/ticker';

register('announcement', [ticker, searchPopdown]);
